export interface phoneorderform {
  openButton: string;
  storeId: string;
  phoneOrderName: string;
  phoneOrderPhone: string;
  phoneOrderEmail: string;
  patientName: string;
  chkSelf: string;
  btnSubmitPhoneOrder: string;
  giftCardMessage: string;
  orderError: string;
  window: string;
}

export function setupPhoneOrderForm(phoneOrderFormIds: phoneorderform) {
  const $window = jQuery("#" + phoneOrderFormIds.window);

  if ($("#" + phoneOrderFormIds.orderError).length) {
    $window.show();
  }

  const $checkoutTypeRadios = $("input:radio[name='checkoutType']");

  $checkoutTypeRadios.click(function (this: HTMLElement) {
    const $this = $(this),
      $emailLabel = $("label[for=" + phoneOrderFormIds.phoneOrderEmail + "]"),
      val = $this.val();

    if (val == "Self") {
      $emailLabel.html("Customer Email *");
      $("#" + phoneOrderFormIds.chkSelf).prop("checked", true);
    } else {
      $emailLabel.html("Customer Email");
      $("#" + phoneOrderFormIds.chkSelf).prop("checked", false);
    }

    //re-validate if any validation errors are currently visible (the messages may change)
    if ($(".error").is(":visible")) {
      validateForm();
    }
  });

  if ($("#" + phoneOrderFormIds.chkSelf).prop("checked") == true) {
    $($checkoutTypeRadios[0]).click();
  } else {
    $($checkoutTypeRadios[1]).click();
  }

  $("#" + phoneOrderFormIds.chkSelf).change(function (this: HTMLElement) {
    const $this = $(this),
      $emailLabel = $("label[for=" + phoneOrderFormIds.phoneOrderEmail + "]");

    if ($this.is(":checked")) {
      $emailLabel.html("Customer Email *");
    } else {
      $emailLabel.html("Customer Email");
    }
  });

  $("#" + phoneOrderFormIds.giftCardMessage).keydown(function (
    this: HTMLElement
  ) {
    const $this = $(this);
    $this.val($this.val().substr(0, 200));
  });

  $window.find(".close-button").click(() => {
    $window.slideUp();
  });

  jQuery(".request-phone").click(function () {
    $window.slideDown();
  });

  jQuery("input[type='tel']").mask("(999) 999-9999");

  function validateForm() {
    const storeIdField = jQuery("#" + phoneOrderFormIds.storeId),
      nameField = jQuery("#" + phoneOrderFormIds.phoneOrderName),
      phoneField = jQuery("#" + phoneOrderFormIds.phoneOrderPhone),
      emailField = jQuery("#" + phoneOrderFormIds.phoneOrderEmail),
      patientNameField = jQuery("#" + phoneOrderFormIds.patientName);

    jQuery("form").validate();

    storeIdField.rules("add", {
      required: true,
      messages: {
        required: "Store ID is required",
      },
    });

    phoneField.rules("add", {
      required: true,
      minlength: 14,
      messages: {
        required: "Phone is required",
        minlength: "Phone is invalid",
      },
    });

    nameField.rules("add", {
      required: true,
      messages: {
        required: "Name is required",
      },
    });

    patientNameField.rules("add", {
      required: true,
      messages: {
        required: "Name is required",
      },
    });

    emailField.rules("add", {
      required: function () {
        return $("input:radio[name='checkoutType']:checked").val() == "Self";
      },
      messages: {
        required: "Email is required for self-checkout",
      },
    });

    let bValid = true;

    bValid = storeIdField.valid() && bValid;
    bValid = nameField.valid() && bValid;
    bValid = phoneField.valid() && bValid;
    bValid = emailField.valid() && bValid;
    bValid = patientNameField.valid() && bValid;

    return bValid;
  }

  jQuery("#" + phoneOrderFormIds.btnSubmitPhoneOrder).click(function (e) {
    if (!validateForm()) {
      e.preventDefault();
      return false;
    }
  });
}
